import "./about_form.css";
import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import AboutSection from './AboutSection';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function AboutForm({website}) {
    const {accent_color, primary_color, setToastMessage, messagesOptions} = useContext(AppContext);
    const { handleAddAboutSection, handleSetAbout, aboutFlag } = useContext(DashboardContext);
    const [editFlag, setEditFlag] = useState(false);
    const [websiteAbout, setWebsiteAbout] = useState(website?.settings?.about);

    useEffect(()=>{
        setWebsiteAbout(website?.settings?.about);
    },[website])
    const handleChanges=(sectionIndex, updatedSection)=>{
        const updated = [...websiteAbout];
        updated[sectionIndex] = updatedSection;
        setWebsiteAbout(updated);
    }
    const handleSave = async()=>{
        setEditFlag(!editFlag);
        try {
            if(editFlag){//still holding the prev state
                await handleSetAbout(website, websiteAbout, setToastMessage, messagesOptions );
            }
        } catch (error) {
            console.error(error);
        }
    }

    
    const deployAboutSections = ()=>{
        return websiteAbout.map((section, inx)=>{
            return <AboutSection key={`aboutSection_inx_${inx}`} section={section} inx={inx} editFlag={editFlag} handleChanges={handleChanges}/>
        })
    }

    return (
        <div className='dashboardForm' dir='rtl'>
            <h2>אודות האתר</h2>
            {deployAboutSections()}
            {websiteAbout.length>0&&<button className="aboutForm_btns" style={{backgroundColor:primary_color, color:accent_color}} onClick={handleSave}>{editFlag ? "שמור" : "ערוך"}</button>}
            <button className="aboutForm_btns" style={{backgroundColor:primary_color, color:accent_color}} onClick={()=>{handleAddAboutSection(website, setToastMessage, messagesOptions)}}>{aboutFlag ? "המתן..." : "הוסף מקטע חדש +"}</button>
        </div>
    )
}
